
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/authentication/LoginPage/LoginPage",
      function () {
        return require("private-next-pages/authentication/LoginPage/LoginPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/authentication/LoginPage/LoginPage"])
      });
    }
  